export const DangerousCharacterRegex = /^[=+,\-@]/;
